import React, { Component } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import en from "date-fns/locale/en-US";
import es from "date-fns/locale/es";
import pt from "date-fns/locale/pt";
import ptBR from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";

import { DateTimerPickerWrapper } from "./styles";
import { CustomInput } from "./CustomInput";

class DateTimerPicker extends Component {
  constructor() {
    super();
    this.state = {
      startDate: new Date(),
    };
  }

  componentDidMount() {
    const { currentValue } = this.props;
    this.setState({ startDate: new Date(currentValue) });
  }

  // Function for change date
  handleDate = (date) => {
    const { updaterFn, name } = this.props;
    this.setState({ startDate: date });
    updaterFn({ prop: name, value: date.toISOString() });
  };

  render() {
    const { startDate } = this.state;
    const { locale, label } = this.props;

    const timeCaption = {
      "pt-BR": "Horário",
      "pt-PT": "Horário",
      en: "Time",
      es: "Tiempo",
    };

    // Condition for register translation
    if (locale === "pt-BR") {
      registerLocale("pt-BR", ptBR);
    } else if (locale === "pt-PT") {
      registerLocale("pt-PT", pt);
    } else if (locale === "en") {
      registerLocale("en", en);
    } else if (locale === "es") {
      registerLocale("es", es);
    }

    return (
      <DateTimerPickerWrapper>
        <p>{label[locale]}</p>
        <DatePicker
          locale={locale}
          selected={startDate}
          onChange={this.handleDate}
          customInput={<CustomInput />}
          dateFormat="PPPpp"
          timeIntervals={15}
          timeFormat="p"
          showTimeSelect
          timeCaption={
            <>
              <p id="hourLabel">{timeCaption[locale]}</p>
              <p id="timezoneLabel">GMT {new Date().getTimezoneOffset() / -60}</p>
            </>
          }
        />
      </DateTimerPickerWrapper>
    );
  }
}

export default DateTimerPicker;
